import {checkSectionVisibility} from '../Common/checkSectionVisibility';

export function populateFollow(jsonData){    

    facebookExcluded = false;
    var twitterExcluded = false;
    followData = jsonData;

    followHeadingText = jsonData.follow.section_heading.value;

    if(jsonData.follow.data.twitter_feed.username){
        twitterUsername = jsonData.follow.data.twitter_feed.username;
    }
    else{
        twitterUsername = "twitterdev";
        twitterExcluded = true;
    }

    if(jsonData.follow.data.facebook_feed.username){
        facebookUsername = jsonData.follow.data.facebook_feed.username;
    }
    else{
        facebookUsername = "facebook";
        facebookExcluded = true;
    }

    if(!$(document).find(".preview").hasClass("hidden")){
        $("#followHeadingText").html(followHeadingText);

        if(twitterExcluded){
            $("#twitterUsername").parent().parent().parent().remove();
        }
        else{
            $("#twitterUsername").html(twitterUsername);
        }

        if(facebookExcluded){
            $("#facebookUsername").parent().parent().parent().remove();
        }
        else{
            $("#facebookUsername").html(facebookUsername);
        }
        
        
    }
    else{                       
        checkSectionVisibility(jsonData.follow.visibility, $(".follow"));
     
        $("input#followHeadingText").val(followHeadingText);

        $("input#twitterUsername").val(twitterUsername);
        $("input#facebookUsername").val(facebookUsername);    
    }

    twttr.widgets.createTimeline(
        {
          sourceType: "profile",
          screenName: twitterUsername,
        },
        document.getElementById("twitterContainer"),
        {
            width: 476,
            height: 549,
            chrome: "nofooter noborders noheader"
        }
    );

    // $(".follow__twitter-container").find(".social-window").find(".twitter-timeline").attr("href", "https://twitter.com/" + twitterUsername);

    // $(".follow__facebook-container").find(".social-window").find("iframe").attr("src", "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F"+ facebookUsername +"%2F&tabs=timeline&width=433&height=640&small_header=false&adapt_container_width=true&hide_cover=true&show_facepile=false&hide_cta=true");

    // $(".follow__facebook-container").find(".social-window").attr("data-href", "https://www.facebook.com/"+ facebookUsername);
    // $(".follow__facebook-container").find(".social-window").find("blockquote").attr("cite", "https://www.facebook.com/"+ facebookUsername);
    // $(".follow__facebook-container").find(".social-window").find("blockquote").find("a").attr("href", "https://www.facebook.com/"+ facebookUsername);

    if(!facebookExcluded){
        $("#fb-social-container").html('<div class="fb-page social-window" data-href="https://www.facebook.com/'+ facebookUsername + '" data-tabs="timeline" data-width="430" data-height="549" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="false"><blockquote cite="https://www.facebook.com/'+ facebookUsername + '" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/'+ facebookUsername + '"></a></blockquote></div>');
    }

    if($(document).find(".preview").hasClass("hidden")){
        document.getElementById('facebookUsername').onkeypress = function(e){
        
            if (!e) e = window.event;
            var keyCode = e.keyCode || e.which;
            if (keyCode == '13'){
                // $(".follow__facebook-container").find(".social-window").find("iframe").attr("src", "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F"+ $("input#facebookUsername").val() +"%2F&tabs=timeline&width=433&height=640&small_header=false&adapt_container_width=true&hide_cover=true&show_facepile=false&hide_cta=true");
            
                // $("#fb-social-container").html('<div class="fb-page social-window" data-href="https://www.facebook.com/'+ $("input#facebookUsername").val() + '" data-tabs="timeline" data-width="476" data-height="549" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="false"><blockquote cite="https://www.facebook.com/'+ $("input#facebookUsername").val() + '" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/'+ $("input#facebookUsername").val() + '"></a></blockquote></div>');
                $(".follow__facebook-container").find(".social-window").find("iframe").attr("src", "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F"+ $("input#facebookUsername").val() +"%2F&tabs=timeline&width=433&height=640&small_header=false&adapt_container_width=true&hide_cover=true&show_facepile=false&hide_cta=true");
                FB.XFBML.parse();
            }
        }
    
        document.getElementById('twitterUsername').onkeypress = function(e){
            
            if (!e) e = window.event;
            var keyCode = e.keyCode || e.which;
            if (keyCode == '13'){
                
                $("#twitterContainer").children().remove();
            
                twttr.widgets.createTimeline(
                    {
                      sourceType: "profile",
                      screenName: $("input#twitterUsername").val()
                    },
                    document.getElementById("twitterContainer"),
                    {
                        width: 476,
                        height: 549,
                        chrome: "nofooter noborders noheader"
                    }
                );
            }
        }
    }
}